import(/* webpackMode: "eager" */ "/app/src/app/energy-calculator/page.jsx");
